import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest-layout',
  templateUrl: './single-column.component.html',
  styleUrls: ['./single-column.component.css']
})
export class SingleColumnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
